<template>
	<v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="720" scrollable persistent>
		<v-card>
			<v-card-title class="d-flex align-center flex-wrap">
				<span>烘焙工作台</span>
				<v-chip v-if="roast.name" class="ml-2" size="small">{{ roast.name }}</v-chip>
				<v-chip v-if="roast.inqty" class="ml-1" size="small" color="warning">{{ roast.inqty }}g</v-chip>
				<v-chip v-if="roast.recipe_id" class="ml-1" size="small" color="primary" variant="tonal">
					配方 #{{ roast.recipe_id }}
				</v-chip>
			</v-card-title>
			<v-card-subtitle class="pb-0">
				<v-stepper :model-value="step" alt-labels class="elevation-0 bg-transparent">
					<v-stepper-header>
						<v-stepper-item :complete="step > 1" :value="1" title="曲线参数" />
						<v-divider />
						<v-stepper-item :complete="step > 2" :value="2" title="完成出库" />
					</v-stepper-header>
				</v-stepper>
			</v-card-subtitle>
			<v-card-text>
				<v-window v-model="step">
					<v-window-item :value="1">
						<v-alert type="info" variant="tonal" density="compact" class="mb-3">
							记录回温、转黄、一爆等参数；录入时不做配方限制，完成后系统自动匹配配方。
						</v-alert>
						<profile-form
							ref="profileForm"
							:roast-id="roastId"
							:errors="profileErrors"
							:show-save-recipe="false"
						/>
					</v-window-item>
					<v-window-item :value="2">
						<v-alert type="info" variant="tonal" density="compact" class="mb-3">
							填写出豆量、Agtron 与烘焙度；提交后将出库入库并尝试关联已有配方。
						</v-alert>
						<complete-form ref="completeForm" :value="completeForm" :errors="completeErrors" />
					</v-window-item>
				</v-window>
			</v-card-text>
			<v-card-actions class="justify-space-between">
				<v-btn variant="text" @click="$emit('update:modelValue', false)">取消</v-btn>
				<div>
					<v-btn v-if="step > 1" variant="outlined" class="mr-2" :loading="saving" @click="step = 1">上一步</v-btn>
					<v-btn v-if="step === 1" color="primary" :loading="saving" @click="goStep2">下一步</v-btn>
					<v-btn v-if="step === 2" color="primary" :loading="saving" @click="submitComplete">完成烘焙</v-btn>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import ProfileForm from './ProfileForm.vue'
import CompleteForm from './CompleteForm.vue'

export default {
	components: { ProfileForm, CompleteForm },
	props: {
		modelValue: Boolean,
		roastId: { type: [Number, String], required: true },
		initialStep: { type: Number, default: 1 }
	},
	emits: ['update:modelValue', 'done'],
	data() {
		return {
			step: 1,
			roast: {},
			completeForm: {},
			profileErrors: {},
			completeErrors: {},
			saving: false
		}
	},
	watch: {
		modelValue(open) {
			if (open) {
				this.step = this.initialStep
				this.profileErrors = {}
				this.completeErrors = {}
				this.loadRoast()
			} else {
				this.step = 1
				this.saving = false
				this.completeForm = {}
			}
		}
	},
	methods: {
		loadRoast() {
			this.$api.roast.getById(this.roastId, (r) => {
				this.roast = r
				this.completeForm = {
					id: r.id,
					name: r.name,
					inqty: r.inqty,
					outqty: r.outqty || null,
					agtron: r.agtron || null,
					agtron_ground: r.agtron_ground || null,
					degree: r.degree || ''
				}
			})
		},
		getProfilePayload() {
			const form = this.$refs.profileForm?.form || {}
			return { ...form, roast_id: this.roastId }
		},
		goStep2() {
			this.saving = true
			this.$api.roast.updateProfile(
				this.getProfilePayload(),
				() => {
					this.saving = false
					const p = this.$refs.profileForm?.form
					if (p?.degree && !this.completeForm.degree) {
						this.completeForm.degree = p.degree
					}
					if (p?.agtron && !this.completeForm.agtron) {
						this.completeForm.agtron = p.agtron
						this.completeForm.agtron_ground = p.agtron_ground
					}
					this.step = 2
				},
				(e) => {
					this.saving = false
					this.profileErrors = e.data && typeof e.data === 'object' ? e.data : { form: e.message }
				}
			)
		},
		submitComplete() {
			this.saving = true
			const saveProfile = () =>
				new Promise((resolve, reject) => {
					this.$api.roast.updateProfile(this.getProfilePayload(), resolve, reject)
				})
			const form = this.$refs.completeForm?.form || this.completeForm
			const payload = {
				...form,
				id: Number(form.id || this.roastId)
			}
			const doComplete = () =>
				new Promise((resolve, reject) => {
					this.$api.roast.complete(payload, resolve, reject)
				})
			saveProfile()
				.then(() => doComplete())
				.then((res) => {
					this.saving = false
					this.$emit('done', { roast: res.roast, recipe_match: res.recipe_match })
					this.$nextTick(() => {
						this.$emit('update:modelValue', false)
					})
				})
				.catch((e) => {
					this.saving = false
					this.completeErrors = e.data && typeof e.data === 'object' ? e.data : { form: e.message }
				})
		}
	}
}
</script>
